import { render, staticRenderFns } from "./PublicPersons1Section.vue?vue&type=template&id=3a0b14d7"
import script from "./PublicPersons1Section.vue?vue&type=script&lang=ts"
export * from "./PublicPersons1Section.vue?vue&type=script&lang=ts"
import style0 from "./PublicPersons1Section.vue?vue&type=style&index=0&id=3a0b14d7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports